import React from 'react';
import { render } from '@testing-library/react';
import { Stack } from './Stack';

describe('Stack', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Stack
				className="w-100"
				justifyContent="center"
				alignItems="center"
				data-auto-sel="automation-selector"
			>
				<div key={1} className="box">
					Stack Item 1
				</div>
				<div key={2} className="box">
					Stack Item 2
				</div>
				<div key={3} className="box">
					Stack Item 3
				</div>
				<div key={4} className="box">
					Stack Item 4
				</div>
				<div key={5} className="box">
					Stack Item 5
				</div>
			</Stack>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
